/**
 * FormationVisual - Container visual for formation blocks
 *
 * Renders player positions in a formation template.
 * Similar to PlayVisual but without drawings/annotations.
 *
 * Pure visual component - no editor state or handlers.
 */

import { BlockRenderer } from '../../BlockRenderer'
import type { BlockVisualProps } from '../../Types'
import type { FormationBlock } from '@/types/blocks/canvas/Formation'
import type { PlayerBlock } from '@/types/blocks/canvas/Player'

export function FormationVisual({ block }: BlockVisualProps) {
	// Type guard
	if (block.type !== 'formation') {
		console.error('FormationVisual called with non-formation block:', block.type)
		return null
	}

	const formationBlock = block as FormationBlock

	// Check for resolved children in properties
	// API should embed players when returning formation
	const players = (formationBlock.properties as any).__resolved_players as
		| PlayerBlock[]
		| undefined

	// No children state
	if (!players || players.length === 0) {
		return (
			<g className="formation-empty">
				<text
					x="0"
					y="0"
					fill="var(--muted-foreground)"
					fontSize="12"
					fontFamily="monospace"
				>
					Formation has no players
				</text>
			</g>
		)
	}

	// Render all player positions recursively
	return (
		<g className="formation-container" data-block-id={formationBlock.id}>
			{players.map((player) => (
				<BlockRenderer key={player.id} block={player} />
			))}
		</g>
	)
}
